// POS System Constants

// Security & Validation
export const AUDIT_DATE_THRESHOLD_HOURS = 6
export const MAX_DISCOUNT_PERCENTAGE = 100
export const MIN_DISCOUNT_PERCENTAGE = 0

// Keyboard Shortcuts
export const KEYBOARD_SHORTCUTS = {
  F4: 115, // Focus discount item
  F5: 116, // Refresh page
  F8: 119, // Focus salesperson field
  F10: 121, // Focus discount amount field
  F11: 122, // Toggle fullscreen
  SPACE: 32, // Pay button
  ENTER: 13, // Confirm/Close dialogs
  DELETE: 46, // Close member dialog
  ESC: 27 // Logout
}

// Search Debounce
export const SEARCH_DEBOUNCE_MS = 500

// Time Updates
export const TIME_UPDATE_INTERVAL_MS = 1000

// Pagination
export const DEFAULT_ITEM_LIMIT = 9

// Phone Number Formatting
export const PHONE_PREFIX_REPLACEMENT = {
  FROM: '0',
  TO: '62'
}

// Customer Types
export const CUSTOMER_TYPES = {
  REGULAR: 'REGULAR',
  RESELLER: 'RESELLER'
}

// Discount Types
export const DISCOUNT_TYPES = {
  PERCENTAGE: 'Persen',
  AMOUNT: 'Rupiah'
}

// Shift Status
export const SHIFT_STATUS = {
  PENDING: 'PENDING',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
}

// Payment Methods (excluded from list)
export const EXCLUDED_PAYMENT_METHODS = ['GIFT', 'VOUCHER']

// Default Payment Method
export const DEFAULT_PAYMENT_METHOD = 'CASH'

// Toast Duration
export const TOAST_DURATION_MS = 3000

// Focus Delay
export const FOCUS_DELAY_MS = 1000
